{{custom-user-selector
  usernames=this.field.value
  includeGroups=this._includeGroups
  includeMentionableGroups=this._includeMentionableGroups
  includeMessageableGroups=this._includeMessageableGroups
  allowedUsers=this._allowedUsers
  single=this._single
  topicId=this._topicId
  disabled=this._disabled
  onChangeCallback=(action "updateFieldValue")
}}